import api from '../api';

import { ParamsBodyEditCustomerAppAddress } from 'utils/typeServices';

export const PostEditCustomerAppAddress = async ({ token, body }: { token: string, body: ParamsBodyEditCustomerAppAddress }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<{ Data: any }>('v2/Cliente/EditCustomerAppAddress', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
